import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Navigate, Route, Routes } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import VoterNavbar from '../components/VoterNavbar'
import uiStore from '../stores/uiStore'
import { getCompetitionMenu, routes } from '../utils/constants'
import { BodySection, DashboardContainer, DashboardWrapper } from './DashboardRoutes'
import CompetitionDashboard from './CompetitionDashboard/CompetitionDashboard'
import useRenderOnAuthenticated from '../hooks/useRenderOnAuthenticated'
import { getCompetitionUsername } from '../utils/helpers'
import CompetitionPayouts from './CompetitionDashboard/CompetitionPayouts'
import VotingRounds from './CompetitionDashboard/VotingRounds'
import CompetitionSettings from './CompetitionDashboard/CompetitionSettings'
import AllowedVoters from './CompetitionDashboard/AllowedVoters'
import seasonStore from '../stores/seasonStore'
import ErrorPage from './ErrorPages/ErrorPage'
import authStore from '../stores/authStore'
import CompetitionAccount from './CompetitionDashboard/CompetitionAccount'
import competitionDashboardStore from '../stores/competitionDashboardStore'


const CompetitionDashboardRoutes = () => {
  const shouldLoadPage = useRenderOnAuthenticated()
  const competitionName = competitionDashboardStore.data.competitionDetails.name

  useEffect(() => {
    competitionDashboardStore.loadDashboardData()
  }, [])

  useEffect(() => {
    uiStore.setNavTitle(competitionName)
  }, [competitionName])

  if (!shouldLoadPage) return null
  if (!competitionDashboardStore.dashboardLoaded) return null
  if (competitionDashboardStore.data.notPermitted) return <ErrorPage code="403" />

  return (
    <DashboardWrapper>
      <Sidebar
        username={competitionDashboardStore.data.competitionDetails.username}
        setSeason={seasonStore.setSelectedSeasonById}
        currentSeason={seasonStore.selectedSeason}
        seasons={seasonStore.seasons}
        menuItems={getCompetitionMenu(competitionDashboardStore.data.competitionDetails)}
        isCompetitionDashboard
        avatar={authStore.userAvatar}
        firstName={authStore.userFirstName} 
        staffRole={competitionDashboardStore.currentStaffRole}
      />
      <BodySection>
        <VoterNavbar 
          competitionPlan={competitionDashboardStore.data.competitionDetails.pricing_subscription} 
          visibility={competitionDashboardStore.data.competitionDetails.visibility}
        />
        <DashboardContainer>
          <Routes>
            <Route path='' element={<Navigate to={routes.COMPETITION_DASHBOARD(getCompetitionUsername() || '')} replace />} />
            <Route path='/home' element={<CompetitionDashboard />} />
            {competitionDashboardStore.isPremierSubscriptionPlan && <Route path='/payouts' element={<CompetitionPayouts />} />}
            <Route path='/voting_rounds' element={<VotingRounds />} />
            <Route path='/settings' element={<CompetitionSettings />} />
            {!competitionDashboardStore.isCompetitionPublic && <Route path='/eligible_voters' element={<AllowedVoters />} />}
            <Route path='/account' element={<CompetitionAccount />} />
          </Routes>
        </DashboardContainer>
      </BodySection>
    </DashboardWrapper>
  )
}

export default observer(CompetitionDashboardRoutes)
